import request from '@/utils/request'

export const getResourceList = (pId) => {
  return request({
    url: `/upms/resource/tree/${pId}`
  })
}

export const postResourceEdit = (data) => {
  return request({
    method: 'post',
    url: '/upms/resource',
    data
  })
}

export const putResourceAdd = (data) => {
  return request({
    method: 'put',
    url: '/upms/resource',
    data
  })
}

export const getResourceDetail = (id) => {
  return request({
    url: `/upms/resource/${id}`
  })
}

export const deleteResourceDel = (id) => {
  return request({
    method: 'delete',
    url: `/upms/resource/${id}`
  })
}

export const getResourceTree = () => {
  return request({
    url: '/upms/resource/tree'
  })
}
